import React, { useEffect } from 'react'
import { useAuth, UserRole, useCompanyMember, CompanyIsAllowed } from '@modmd/data'
import { Tabber } from 'components/Tabber'
import { TestsUserDetails } from 'sharedComponents/TestsUserDetails'
import { EventClearenceUser } from 'sharedComponents/EventClearenceUser'
import { BusinessUser } from 'sharedComponents/BusinessUser'
import { AboutUser } from 'sharedComponents/AboutUser'
import { DatalistType } from './constants'
import useTabber from '../../../hooks/useTabber'
import { ConfirmInsurance } from '../ConfirmInsurance'
import { useLocation } from 'react-router'

interface Props {
  userId: string
}

interface LocationState {
  state?: {
    vaccine?: string
  }
}

export const UserDatalists = ({ userId }: Props) => {
  const location: LocationState = useLocation()
  const { hasRoles } = useAuth()
  const auth = useAuth()
  const isSuperAdmin = hasRoles([UserRole.SUPER_ADMIN])
  const isCLS = hasRoles([UserRole.CLS])
  const isNurseOrResults = hasRoles([UserRole.NURSE, UserRole.RESULTS])
  const isAdmin = hasRoles([UserRole.ADMIN])
  const isScheduler = hasRoles([UserRole.SCHEDULER])
  const { data: isCompanyAllowed } = useCompanyMember({
    userId: auth.data.User.id,
  }) as CompanyIsAllowed
  const { currentTab, setCurrentTab } = useTabber()

  useEffect(() => {
    if (location.state?.vaccine) {
      setCurrentTab(DatalistType.EventClearence)
    }
  }, [location.state])

  return (
    <>
      {(isSuperAdmin ||
        isCLS ||
        isAdmin ||
        isCompanyAllowed?.companyMember ||
        isNurseOrResults ||
        isScheduler) && (
        <>
          <Tabber
            activeTabName={currentTab}
            onChange={({ activeTabName }) => {
              setCurrentTab(activeTabName)
            }}
          >
            <Tabber.Item
              tabName={DatalistType.Tests}
              permissions={[
                UserRole.SUPER_ADMIN as UserRole,
                UserRole.CLS as UserRole,
                UserRole.ADMIN as UserRole,
                UserRole.NURSE as UserRole,
                UserRole.RESULTS as UserRole,
                UserRole.SCHEDULER as UserRole,
              ]}
              component={<TestsUserDetails userId={userId} />}
            >
              Tests
            </Tabber.Item>
            <Tabber.Item
              tabName={DatalistType.About}
              permissions={[
                UserRole.SUPER_ADMIN as UserRole,
                UserRole.CLS as UserRole,
                UserRole.RESULTS as UserRole,
                UserRole.SCHEDULER as UserRole,
              ]}
              component={<AboutUser userId={userId} />}
            >
              About
            </Tabber.Item>
            <Tabber.Item
              tabName={DatalistType.EventClearence}
              permissions={[
                UserRole.SUPER_ADMIN as UserRole,
                UserRole.CLS as UserRole,
                UserRole.ADMIN as UserRole,
                UserRole.NURSE as UserRole,
                UserRole.RESULTS as UserRole,
              ]}
              component={
                <EventClearenceUser
                  userId={userId}
                  isSuperAdmin={isSuperAdmin || isCLS}
                  isAdmin={isAdmin}
                  isNurseOrResults={isNurseOrResults}
                />
              }
            >
              Event Clearance
            </Tabber.Item>
            <Tabber.Item
              tabName={DatalistType.Business}
              permissions={[UserRole.SUPER_ADMIN as UserRole, UserRole.CLS as UserRole]}
              component={<BusinessUser userId={userId} />}
            >
              Business
            </Tabber.Item>
            <Tabber.Item
              tabName={DatalistType.Insurance}
              permissions={[
                UserRole.SUPER_ADMIN as UserRole,
                UserRole.CLS as UserRole,
                UserRole.ADMIN as UserRole,
                UserRole.NURSE as UserRole,
                UserRole.RESULTS as UserRole,
              ]}
              component={<ConfirmInsurance insuranceUserId={Number(userId)} />}
            >
              Insurance
            </Tabber.Item>
          </Tabber>
        </>
      )}
    </>
  )
}
